import { useState, useMemo } from "react";
import SubscriptionsList from "./SubscriptionsList";

const MySubscriptions = ({ account,fetchSubscriptions }) => {
  return (
    <div className="mt-6 flex flex-col items-start justify-start gap-6 w-full">
      {/* a List or Placeholder */}
      {account?.length > 0 && <SubscriptionsList list={account} fetchSubscriptions={fetchSubscriptions} />}
    </div>
  );
};

export default MySubscriptions;
